import React, { useState } from 'react';
import MultiSelectCheckboxGroup from '../../components/CheckBoxFilter';
import VerticalTable from '../../components/verticalTable';
import { useTranslation } from 'react-i18next';
import { sixMonthsAgoFormatted, twoDaysAgoFormatted } from '../../constants/intex';

const TeleCalling = () => {
  const { t } = useTranslation();
  
  
  const [selectedFilters, setSelectedFilters] = useState<Record<string, string[]>>({
    periodWithOutDay: ["month"],
    fromDate: [sixMonthsAgoFormatted],
    toDate: [twoDaysAgoFormatted],
  });

  const filters = [
    { key: "state", type: "select", label: t("filters.state") },
    // { key: "territory", type: "select", label: t("filters.territory") },
    { key: "cluster", type: "select", label: t("filters.cluster") },
    { key: "branch", type: "select", label: t("filters.branch") },
    { key: "periodWithOutDay", type: "singleSelect", label: t("filters.period") },
    { key: "fromDate", type: "date", label: t("filters.fromDate"), maxValue: selectedFilters.toDate },
    { key: "toDate", type: "date", label: t("filters.toDate"), maxValue: twoDaysAgoFormatted },
  ];

  const [applyFilter, setApplyFilter] = useState<boolean>(false);

  const handleFilterChange = (updatedValues: Record<string, string[]>) => {
    setSelectedFilters(updatedValues);
  };

  const handleCancelClick = () => {
    setSelectedFilters({
      periodWithOutDay: ["month"],
      fromDate: [sixMonthsAgoFormatted],
      toDate: [twoDaysAgoFormatted]
    });
    setApplyFilter(!applyFilter);
  };

  // --- Reminder Calls Table ---
  const reminderHeaders = ["", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Total"];
  const reminderData = [
    { category: "# of Accounts", values: ["350", "400", "380", "320", "353", "1803"] },
    { category: "# of reminders made", values: ["300", "350", "340", "300", "320", "1610"] },
    { category: "# of reminders connected", values: ["190", "240", "230", "200", "260", "1120"] },
  ];

  // --- Connect % Table ---
  const connectHeaders = ["", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Total"];
  const connectData = [
    { category: "# not connected", values: ["110", "110", "110", "100", "90", "520"] },
    { category: "# connected", values: ["190", "240", "230", "200", "260", "1120"] },
    { category: "# of accounts", values: ["350", "400", "380", "320", "353", "1803"] },
  ];

  return (

      <div className="page-content">
      <div className="header">
      {t('Telecalling.pageTitle')}
      </div>

      {/* Filters */}
      <div className="content px-3">
        <MultiSelectCheckboxGroup
          filters={filters}
          selectedValues={selectedFilters}
          onChange={handleFilterChange}
          isLoading={[false]}
          buttons={[
            { label: t("buttons.apply"), onClick: () => setApplyFilter(!applyFilter) },
            { label: t("buttons.cancel"), onClick: handleCancelClick },
            { label: t("buttons.download"), onClick: () => alert("Download triggered") },
          ]}
        />
      </div>

      {/* Summary Cards */}
      <div className="d-flex gap-5 mb-4 justify-content-center mt-3">
  <div style={{ border: '1px solid #000', padding: '20px', borderRadius: '0px', width: '150px', textAlign: 'center' }}>
    <div style={{ fontSize: '20px', fontWeight: 600 }}>1803</div>
    <div style={{ fontSize: '14px' }}>{t('Telecalling.Accounts')}</div>
  </div>
  <div style={{ border: '1px solid #000', padding: '20px', borderRadius: '0px', width: '150px', textAlign: 'center' }}>
    <div style={{ fontSize: '20px', fontWeight: 600 }}>63%</div>
    <div style={{ fontSize: '14px' }}>{t('Telecalling.Connect')}</div>
  </div>
</div>


      {/* Reminder Calls Table */}
      <div className="p-2 me-3">
        <h2 style={{ fontSize: 15, fontWeight: 600, fontFamily: 'Arial', textAlign: "start", paddingLeft: "15px", color: '#14213d' }}>
        {t('Telecalling.Calls')}
        </h2>
        <VerticalTable headers={reminderHeaders} data={reminderData} loading={false} />
      </div>

      {/* Connect % Table */}
      <div className="p-2 me-3 mt-5">
        <h2 style={{ fontSize: 15, fontWeight: 600, fontFamily: 'Arial', textAlign: "start", paddingLeft: "15px", color: '#14213d' }}>
        {t('Telecalling.Connect_Table')}
        </h2>
        <VerticalTable headers={connectHeaders} data={connectData} loading={false} />
      </div>
    </div>
  );
};

export default TeleCalling;
